import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	OnInit,
	signal,
} from '@angular/core';
import { StorageService } from '@context/frontend/storage';
import {
	ContentMedia,
	getExtension,
	getMediaIcon,
} from '@context/shared/types/media';
import { TuiHint } from '@taiga-ui/core';
import { TuiAvatar } from '@taiga-ui/kit';

@Component({
	imports: [TuiAvatar, TuiHint],
	selector: 'ctx-media-thumbnail',
	templateUrl: 'media-thumbnail.component.html',
	styleUrl: 'media-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaThumbnailComponent implements OnInit {
	readonly media = input.required<ContentMedia>();

	readonly badgeIcon = input<string | null>(null);

	readonly badgeHint = input<string | null>(null);

	readonly storageService = inject(StorageService);

	readonly thumbnailUrl = signal<string | null>(null);

	readonly icon = computed(() => {
		const ext = getExtension(this.media().name);
		return getMediaIcon(ext.slice(1));
	});

	async ngOnInit() {
		const media = this.media();
		if (!media.thumbnailPath) return;

		const ref = this.storageService.getReference(media.thumbnailPath);
		const url = await this.storageService.getDownloadUrl(ref);
		this.thumbnailUrl.set(url);
	}
}
